import React from 'react'
import SVGIcon from '../helpers/icons'
import PropTypes from 'prop-types'

function ArrowLinkBox ({title = null, description = null, border = true, onClick = null}) {
  const titleMarkup = title ? <div className={'arrow-link-box__title'}><span>{title}</span><SVGIcon
    type={'arrow-right'} fill={'#444444'} className={'arrow-link-box__icon'}/></div> : null
  const descriptionMarkup = description ? <div className={'arrow-link-box__desc'}>{description}</div> : null
  const classNames = border ? 'arrow-link-box arrow-link-box--border' : 'arrow-link-box'

  return (
    <div className={classNames}>
      <a className={'arrow-link-box__link'} onClick={() => onClick()}>
        {titleMarkup}
        {descriptionMarkup}
      </a>
    </div>
  )
}

export default ArrowLinkBox